import React from 'react';
import type { ClassesProp } from '@/models/ClassesProp';

const Divider = ({ classes }: ClassesProp) => {
  const className = `${classes} border-b-[1px] flex-grow border-neutral-10`;
  return <div className={className} />;
};
export default Divider;
